module.exports = __webpack_public_path__ + "static/media/Loaded.e6cc3725.png";